@import './cms-service-teaser.scss';

.text-wrapper {
  font-weight: var(--cms-heading-base-font-weight);
}